const PATHS = {
  scale: 'M12 3v18M5 7h14M7 7l-3 6h6L7 7zm10 0l-3 6h6l-3-6zM8 21h8',
  sync: 'M20 12a8 8 0 01-13.7 5.6M4 12a8 8 0 0113.7-5.6M4 6v4h4M20 18v-4h-4',
  users: 'M16 20v-1.5a4 4 0 00-4-4H7a4 4 0 00-4 4V20M9.5 6.5a3 3 0 11-6 0 3 3 0 016 0zM21 20v-1.5a4 4 0 00-3-3.9M16 4.6a3 3 0 010 5.8',
  server: 'M4 5h16v5H4zM4 14h16v5H4zM7.5 7.5h.01M7.5 16.5h.01',
  receipt: 'M6 3h12v18l-2-1.5L14 21l-2-1.5L10 21l-2-1.5L6 21zM9 8h6M9 12h6',
  shield: 'M12 3l8 3v6c0 4.4-3.2 7.6-8 9-4.8-1.4-8-4.6-8-9V6l8-3zM9 12l2 2 4-4',
  badge: 'M12 3l2.4 1.6 2.9-.3 1 2.7 2.4 1.6-1 2.7 1 2.7-2.4 1.6-1 2.7-2.9-.3L12 20l-2.4-1.6-2.9.3-1-2.7L3.3 14l1-2.7-1-2.7 2.4-1.6 1-2.7 2.9.3zM9.5 12l1.8 1.8 3.4-3.6',
  clock: 'M12 21a9 9 0 100-18 9 9 0 000 18zM12 7v5l3.5 2',
  lock: 'M6 10h12v10H6zM9 10V7a3 3 0 016 0v3M12 14v2.5',
  wallet: 'M4 7h13a3 3 0 013 3v7a3 3 0 01-3 3H5a1 1 0 01-1-1V7zM4 7a2 2 0 012-2h9M17 13.5h.01',
  mail: 'M3 6h18v12H3zM3 7l9 6 9-6',
  phone: 'M6.5 3h3l1.5 4-2 1.5a12 12 0 006 6l1.5-2 4 1.5v3a2 2 0 01-2.2 2A17 17 0 014.5 5.2 2 2 0 016.5 3z',
  pin: 'M12 21s7-5.3 7-11a7 7 0 10-14 0c0 5.7 7 11 7 11zM12 12a2.5 2.5 0 100-5 2.5 2.5 0 000 5z',
  check: 'M4 12.5l5 5L20 6.5',
  chat: 'M4 5h16v11H9l-5 4V5zM8 9h8M8 12.5h5',
  headset: 'M4 14v-2a8 8 0 1116 0v2M4 14h3v5H6a2 2 0 01-2-2v-3zm16 0h-3v5h1a2 2 0 002-2v-3z',
  cart: 'M3 4h2.2l2 11h10l2-8H6M9.5 19.5h.01M17 19.5h.01',
  star: 'M12 3.5l2.7 5.6 6.1.9-4.4 4.3 1 6.2-5.4-2.9-5.4 2.9 1-6.2L3.2 10l6.1-.9z',
  download: 'M12 3v11M7.5 10L12 14.5 16.5 10M4 19h16',
  spark: 'M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z',
};

export default function Icon({ name, size = 22, className = '' }) {
  const d = PATHS[name];
  if (!d) return null;

  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d={d} />
    </svg>
  );
}
